import { InviteApiClientImpl } from './InviteApiClient';
import { PermsApiClient } from './PermsApiClient';
import { AccountInfoClient } from './AccountInfoClient';
import { OpenInviteClient } from './OpenInviteClient';
import {
	HaveISeenItClient,
	createHISIDomainFlagKey,
	createHISIOpenInviteFlagKey,
} from './HaveISeenItClient';
import { PersonalizationClient } from './PersonalizationClient';
import { InviteThirdPartyTeamsClient } from './InviteThirdPartyTeamsClient';
export { INVITE_API_MAX_USERS } from './InviteApiClient';

export const defaultPersonalizationClient = new PersonalizationClient();
export const defaultInviteApiClient = new InviteApiClientImpl();
export const defaultPermsApiClient = new PermsApiClient();
export const defaultAccountInfoClient = new AccountInfoClient();
export const defaultOpenInviteClient = new OpenInviteClient();
export const defaultHaveISeenItClient = new HaveISeenItClient();
export { createHISIDomainFlagKey, createHISIOpenInviteFlagKey };
export const defaultInviteThirdPartyTeamsClient = new InviteThirdPartyTeamsClient();
